// Resolves the job's CLIENT rate ceiling from the clicked job record. jobPayDetails
// is normally a flat object, but if a deployment stores it as a history ARRAY the
// last element is the current one — hence "the last array index". Falls back to the
// flat clientBudget shape. Returns the max the candidate rate may reach, or null.
function clientRateCeiling(job = {}) {
  const pd = Array.isArray(job.jobPayDetails)
    ? job.jobPayDetails[job.jobPayDetails.length - 1]
    : (job.jobPayDetails ?? job.clientBudget ?? {});
  const end = Number(pd.clientBudgetEnd);
  const start = Number(pd.clientBudgetStart);
  if (Number.isFinite(end) && end > 0) return end;
  if (Number.isFinite(start) && start > 0) return start;
  return null;
}

// candidateRate validator — shared by the field's Form.Item rule. Enforces:
//   • range "To" strictly greater than "From"
//   • the entered rate not exceeding the job's client rate ceiling.
function validateCandidateRate(value, context) {
  const v = value ?? {};
  if (v.isRange && v.minAmount != null && v.maxAmount != null
    && Number(v.maxAmount) <= Number(v.minAmount)) {
    return 'To rate must be greater than From rate.';
  }
  const ceiling = clientRateCeiling(context?.selectedRecords?.[0] ?? {});
  const entered = v.isRange ? Number(v.maxAmount) : Number(v.amount);
  if (ceiling != null && Number.isFinite(entered) && entered > ceiling) {
    return `Candidate rate must not exceed the client rate (${ceiling}).`;
  }
  return '';
}

export const config = {
  getTitleText: (_count, _itemLabel, record) => {
    const jobName = record?.jobTitle || record?.title || '';
    return jobName ? `Assign - ${jobName}` : 'Assign';
  },
  okText: 'Assign',
  width: 520,
  disabledUntilFilled: true,
  showAlreadyAssigned: true,
  // getFields (not a static list) so the candidate-rate field can carry the
  // clicked job's client-rate ceiling for the inline hint + validator.
  getFields: (context) => {
    const ceiling = clientRateCeiling(context?.selectedRecords?.[0] ?? {});
    return [
      {
        name: 'assignToUserId',
        label: 'Assign to',
        // Multi-select: one Assign can add several recruiters at once. The submit
        // merges every selected id into recruitersData, which the backend
        // (ResolveAssignmentRecruiterIDs) unions with the existing recruiters.
        type: 'multi-select',
        required: true,
        placeholder: 'Select recruiter(s)',
        fetchOptionsKey: 'assignToUsers',
      },
      {
        name: 'candidateRate',
        label: 'Candidate Rate',
        type: 'candidate-rate',
        rateCeiling: ceiling,
        validator: validateCandidateRate,
      },
      {
        name: 'priority',
        label: 'Priority',
        type: 'priority-checkbox',
        checkboxLabel: 'Mark as High',
      },
    ];
  },
};
